export const SET_TEMPLATES = "setTemplates";
export const CLEAR_TEMPLATES = "clearTemplates";
export const SET_TOTAL_TEMPLATES = "setTotalTemplates";
export const CLEAR_TOTAL_TEMPLATES = "clearTotalTemplates";
export const SET_TEMPLATE = "setTemplate";
export const CLEAR_TEMPLATE = "clearTemplate";
export const SET_TYPE = "setType";
export const SET_NAME = "setName";
export const SET_LANGUAGE = "setLanguage";
export const SET_DEFAULT = "setDefault";
export const ADD_ITEM = "addItem";
export const REMOVE_ITEM = "removeItem";
export const CLEAR_ITEMS = "clearItems";
export const CLEAR_ITEMS_BY_LANGUAGE = "clearItemsByLanguage";
export const SET_SELECTED_ITEM_INDEX = "setSelectedItemIndex";
export const CLEAR_SELECTED_ITEM_INDEX = "clearSelectedItemIndex";
export const SET_CURRENT_LANGUAGE = "setCurrentLanguage";
export const CLEAR_CURRENT_LANGUAGE = "clearCurrentLanguage";
export const UPDATE_ITEM = "updateItem";
export const DUPLICATE_ITEM = "duplicateItem";
